import { j as g } from "../../../jsx-runtime-B6kdoens.js";
import { useEffect as C } from "react";
import { c as A } from "../../../index-CROKJrb5.js";
import { c as h, f as M } from "../../../create-component-CBAeEoQ6.js";
import { u as N } from "../../../use-dimensions-CSpaxs3M.js";
import { u as x } from "../../../use-merge-refs-DEJnLwh4.js";
import { u as R } from "../../../NavigationState-EOPjgMu1.js";
import { u as s, a as w } from "../../../react-B_GApDuV.js";
const j = A({
  base: "cur-flex cur-gap-2 cur-items-center",
  variants: {
    hasComputed: {
      false: "cur-invisible"
    }
  }
}), V = h(
  "NavigationMinimal",
  M(
    ({ children: i, className: a, ...e }, r) => {
      const {
        isBreakpointCollapsedAtom: m,
        hasComputedAtom: n,
        isOverflowCollapsedAtom: l,
        navigationMinimalWidthAtom: f
      } = R(), u = s(m), p = s(l), c = s(n), t = w(f), [d, o] = N();
      C(() => {
        t((o == null ? void 0 : o.width) || 0);
      }, [t, o]);
      const v = x(d, r);
      return !u && !p ? null : /* @__PURE__ */ g.jsx(
        "div",
        {
          className: j({
            className: a,
            hasComputed: c
          }),
          ref: v,
          ...e,
          children: i
        }
      );
    }
  )
);
export {
  V as NavigationMinimal
};
//# sourceMappingURL=index.js.map
